import { Modal } from '@/components/ui'
import { IoSettings, IoCheckmarkDone } from 'react-icons/io5'
import { HiHome, HiSearch, HiBell, HiUser } from 'react-icons/hi'

interface PreviewModalProps {
  open: boolean
  onClose: () => void
  title: string
  content: string
  eventName?: string
}

export const PreviewModal: React.FC<PreviewModalProps> = ({
  open,
  onClose,
  title,
  content,
  eventName = 'AVA Events',
}) => {
  const safeContent = (content || '').trim() || 'Welcome to the event!'
  const contentHtml = safeContent.replace(/\n/g, '<br />')

  return (
    <Modal
      title="Preview"
      open={open}
      onClose={onClose}
      footer={null}
      width={400}
      centered
    >
      <div className="flex justify-center py-4">
        {/* iPhone mockup */}
        <div className="relative w-[280px] h-[560px] bg-white rounded-[40px] border-[10px] border-gray-800 shadow-xl overflow-hidden">
          {/* Notch */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[120px] h-[30px] bg-gray-800 rounded-b-2xl z-10" />

          {/* Status bar */}
          <div className="flex justify-between items-center px-6 pt-2 text-xs text-black">
            <span className="font-semibold">9:41</span>
            <div className="flex items-center gap-1">
              <span className="text-xs">●●●●</span>
              <span className="text-xs">📶</span>
              <span className="text-xs">🔋</span>
            </div>
          </div>

          {/* Content area */}
          <div className="h-full pt-8 pb-20 px-4 bg-gray-50">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-semibold text-black">Notifications</h2>
              <div className="flex items-center gap-2">
                <button className="p-1 text-gray-500">
                  <IoSettings className="w-5 h-5" />
                </button>
                <button className="p-1 text-gray-500">
                  <IoCheckmarkDone className="w-5 h-5" />
                </button>
              </div>
            </div>

            {/* Notification item */}
            <div className="bg-white rounded-lg p-3 shadow-sm border border-gray-100">
              <div className="flex items-start gap-3">
                <div className="relative">
                  <div className="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-lg font-bold">
                      {(eventName || 'A')[0]}
                    </span>
                  </div>
                  <div className="absolute -top-0.5 -left-0.5 w-2.5 h-2.5 bg-blue-500 rounded-full border-2 border-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-semibold text-black/60 mb-1">
                    {title || 'Push Notification'}
                  </p>
                  <p className="text-sm text-black leading-relaxed">
                    <span dangerouslySetInnerHTML={{ __html: contentHtml }} />
                  </p>
                </div>
                <div className="flex flex-col items-end gap-1">
                  <span className="text-xs text-gray-400">2m</span>
                  <button className="text-gray-400">
                    <span className="text-lg">•••</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom navigation */}
          <div className="absolute bottom-0 left-0 right-0 h-16 bg-white border-t border-gray-200 flex items-center justify-around px-4">
            <button className="flex flex-col items-center text-gray-400">
              <HiHome className="w-6 h-6" />
              <span className="text-[10px] mt-0.5">Home</span>
            </button>
            <button className="flex flex-col items-center text-gray-400">
              <HiSearch className="w-6 h-6" />
              <span className="text-[10px] mt-0.5">Explore</span>
            </button>
            <button className="flex flex-col items-center text-blue-500">
              <HiBell className="w-6 h-6" />
              <span className="text-[10px] mt-0.5">Notifications</span>
            </button>
            <button className="flex flex-col items-center text-gray-400">
              <HiUser className="w-6 h-6" />
              <span className="text-[10px] mt-0.5">Profile</span>
            </button>
          </div>

          {/* Home indicator */}
          <div className="absolute bottom-1 left-1/2 -translate-x-1/2 w-32 h-1 bg-gray-800 rounded-full" />
        </div>
      </div>
    </Modal>
  )
}
